<template>
  <!-- 应收款明细表 -->
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-tree @node-click="nodeClick"></erp-tree>
  </div>
  <div class="d-flex-right">
    <!-- 设置 -->
    <div v-if="seup == 2" style="width: 99.8%;">
      <div style="margin-bottom: 5px;">
         <el-button @click="postAdd">保存</el-button>
         <el-button @click="tup">返回</el-button>
      </div>

      <div class="cdj_div">
        <div>收费对象设置，房间：{{item.address}}（{{item.ChargeItemTypeID}}->{{item.chargeItem_name}}->{{item.charge_name}}）</div>
      </div>
      <div class="cdj_table">
        <div class="cdj_display">
          <div class="cdj_left" style="width: 100%;">
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">设置</div>
              <div class="cdj_el-input" style="margin-top: 3px;">
                  <el-checkbox v-model="checked_up[0]"  :true-label="1" >将承担比率设置到该房间所有收费项目</el-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-button-group style="margin-top: 5px;">
        <el-button @click="userPost(1)">添加</el-button>
        <el-button @click="userPost(2)">业主</el-button>
        <el-button @click="userPost(3)">租户</el-button>
        <el-button @click="userPost(4)">开发商</el-button>
        <el-button @click="userPost(5)">移除</el-button>
      </el-button-group>
      <div style="margin-top: 2px;width: 99.8%;height: 600px;">
        <el-table :data="chargeitem_list" height="600" border style="width: 99.8%">
            <el-table-column prop="" label="选" width="80">
              <template slot-scope="scope">
                <!-- 多选框 -->
                <el-checkbox  v-model="checked_list['checked'+scope.$index]" @change="checked_scope(scope.row.id,scope.$index)" :true-label='scope.row.id'></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="收费对象" width="230">
              <template slot-scope="scope">
                <el-button @click="updates(scope.$index)" size="mini">修改</el-button><span style="margin-left:5px;">{{chargeitem_list[scope.$index].name}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="Rate" label="承担比率" width="180">
              <template slot-scope="scope">
                <el-input v-model="chargeitem_list[scope.$index].Rate" placeholder=""></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="chargeItem_name" label="备注">
              <template slot-scope="scope">
                <el-input v-model="chargeitem_list[scope.$index].Remark" placeholder="备注"></el-input>
              </template>
            </el-table-column>
          </el-table>
      </div>
    </div>
    <!-- 列表 -->
    <div v-if="seup == 1">
        <div style="margin-bottom: 5px;">
           <el-button @click="searchs">搜索</el-button>
           <el-button @click="del">清除</el-button>
           <el-button @click="del_list">全部清除</el-button>
         </div>
         <div class="cdj_div">查询条件</div>
         <div class="cdj_table">
           <div class="cdj_display">
             <div class="cdj_left">
               <div class="cdj_left_display">
                 <div class="cdj_left_display_background">费用类型</div>
                 <div class="cdj_el-input">
                   <el-select
                       v-model="data.chargeitem_type_id"
                       style="width: 100%"
                       clearable
                       @change="chargeitem_types"
                       placeholder="费用类型">
                       <el-option
                         size="mini"
                         v-for="item in chargeitem_type"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
                       </el-option>
                     </el-select>
                 </div>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">收费项目</div>
                 <div class="cdj_el-input">
                   <el-select
                       v-model="data.chargeItem_name_id"
                       style="width: 100%"
                       clearable
                       @change="chargeItem_names"
                       placeholder="收费项目">
                       <el-option
                         size="mini"
                         v-for="item in chargeitem_1"
                         :key="item.id"
                         :label="item.chargeItem_name"
                         :value="item.id">
                       </el-option>
                     </el-select>
                 </div>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">收费标准</div>
                 <div class="cdj_el-input">
                   <el-select
                       v-model="data.name"
                       style="width: 100%"
                       clearable
                       placeholder="收费标准">
                       <el-option
                         size="mini"
                         v-for="item in charge"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
                       </el-option>
                     </el-select>
                 </div>
               </div>
             </div>
             <div class="cdj_left">
               <div class="cdj_left_display">
                 <div class="cdj_left_display_background">当前房产</div>
                 <el-select
                     v-model="search"
                     class="cdj_el-input"
                     filterable
                     remote
                     clearable
                     reserve-keyword
                     placeholder="可搜索房产/客户姓名"
                     :remote-method="remoteMethod"
                     :loading="loading">
                     <el-option
                       v-for="item in selectList"
                       :key="item.id"
                       :label="item.house"
                       :value="item.house">
                     </el-option>
                   </el-select>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">收费对象</div>
                 <div class="cdj_el-input el-date-pickers">
                   <el-select v-model="data.names" style="width: 100%;margin-left: 2px;" size="mini" :remote-method="remoteMethods" clearable filterable remote reserve-keyword  placeholder="搜索客户姓名">
                     <el-option
                       v-for="item in user"
                       :key="item.name"
                       :label="item.name"
                       :value="item.name">
                     </el-option>
                   </el-select>

                    <!-- <el-select
                        v-model="data.chargeitemID"
                        style="width: 100%"
                        clearable
                        placeholder="收费对象">
                        <el-option
                          v-for="item in charge"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select> -->
                 </div>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">设置情况</div>
                   <div class="cdj_el-input el-date-pickers" style="margin-top: 3px;">
                     <el-checkbox-group v-model="data.status">
                        <el-checkbox label="已设置" name="type"></el-checkbox>
                        <el-checkbox label="未设置" name="type"></el-checkbox>
                      </el-checkbox-group>
                   </div>
               </div>
             </div>
           </div>
         </div>
         <div style="margin-top: 5px;"></div>
         <el-table ref="multipleTable" :data="desserts" border tooltip-effect="dark" style="width: 100%" height="47vh" @selection-change="handleSelectionChange">
           <el-table-column type="selection" width="55"></el-table-column>
           <el-table-column prop="id" label="ID" width="80"></el-table-column>
           <el-table-column prop="address" label="房产" show-overflow-tooltip></el-table-column>
           <el-table-column prop="ChargeItemTypeID" label="费用类型" width="130"></el-table-column>
           <el-table-column prop="chargeItem_name" label="收费项目" width="130"></el-table-column>
           <el-table-column prop="meter_number" label="仪表编号" width="130"></el-table-column>
           <el-table-column prop="charge_name" label="收费标准" width="200"></el-table-column>
           <el-table-column prop="price" label="单价" width="60"></el-table-column>
           <el-table-column prop="customer_name" label="收费对象" width="130"></el-table-column>
           <el-table-column prop="customer_rate" label="比率" width="80"></el-table-column>
           <el-table-column label="操作" width="80">
             <template slot-scope="scope">
               <div style="display: flex;">
                 <div style="color: #1867c0;cursor: pointer;" @click="setup(scope.row)">设置</div>
               </div>
             </template>
           </el-table-column>
         </el-table>
         <div class="pages" v-if="desserts">
           <Page :total="total" :page-size="page" @on-change="change"  show-total />
         </div>
         <div class="zhanwu" v-else>没有数据</div>
       </div>
    </div>

    <!-- 弹窗选择用户 -->
    <Modal
      v-model="modal1"
      width="800"
      title="选择客户"
      @on-ok="roomUser">
      <div>
        <room-user style="height: 600px;" ref="child" :house="house"></room-user>
      </div>
    </Modal>

</div>

</template>

<script>
import imgurl from "../../../../assets/js/imgurl.js";
export default {
  name: "FormsOweMoney",
  data () {
    return {
      modal1:false,
      seup:1,
      checkeds:'',
      checked:[],
      checked_list:[],
      selectList:[],
      checked_up:[],
      project_id:'',
      radio:'1',
      startDate:'',
      endDate:'',
      chargeitem:[],
      chargePercentage:'',
      chargePercentage1:'',
      money:'--',
      loading:false,
      desserts: '',
      total:0,
      page:12,
      search:'',
      state:0,
      chargeitem_list:[],
      data:{
        pid:'',
        house_id:'',
        homeName:'',
        startDate:'',
        endDate:'',
        chargeitemID:[],
        names:'',
        chargeitem_type_id:'',
        chargeItem_name_id:'',
        status:[],
      },
      chargeitem_type:[],
      chargeitem_1:[],
      charge:[],
      data_list:[],
      homeName:'',
      type:'',
      item:[],
      house:'',
      room_users:'',
      index:1,
      user_index:'',
      user:[],
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    this.change(1);
    //加载收费大类（费项）
    this.$myhttp.get('admin/common/getChargeitem',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.chargeitem = backdata.data.data;
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //搜索客户
    remoteMethods(query) {
      this.data.name = query;
      this.$myhttp.post('admin/RoomSetUpUser/username',this.data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.user = backdata.data.data;
      });
    },
    //统计
    userPost(type){
      //console.log(type)
      //console.log(this.chargeitem_list);
      //console.log(this.item);
      //添加
      if(type == 1){
        let data = {
          DBID: '',
          IsMerge: '',
          Rate: "1.0000",
          Remark: '',
          SubID: '',
          customer_id: '',
          id: '',
          name: "",
          standard_id: this.item.id,
          xsc_CustomerID: '',
          xsc_HouseChargeID: '',
          xsc_PaidCustomerType: "",
          xsc_id: '',
          checked:false,
        }
        this.chargeitem_list.push(data);
      }
      //业主，租户
      if(type == 2 || type == 3){
        let data_liet = {'chargeitem_list':this.chargeitem_list,'type':type,'item':this.item};
        ERP.showLoading();
        this.$myhttp.post('admin/RoomSetUpUser/user',data_liet,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            ERP.hideLoading();
            if(backdata.data.code == 200){
              this.chargeitem_list = backdata.data.data;
              this.$Message.success(backdata.data.message);
            }else{
              this.$Message.error(backdata.data.message);
            }
        });
      }
      //开发商
      if(type == 4){
          this.index = 1;
          this.modal1 = true;
      }
      //移除
      if(type == 5){
        let bool = false;
        let data_list = [];
        this.checked_list = [];
        this.chargeitem_list.map(request=>{
          if(request.checked == true){
            bool = true;
          }else{
            data_list.push(request);
          }
        })
        if(bool == false){
          this.$Message.error("没有选中行");
        }else{
          this.$Message.success("操作成功");
          this.chargeitem_list = data_list;
        }
      }
    },
    //点击开发商
    roomUser(){
      let user = this.$refs.child.getUser();
      if(user.id){
        let data = {
          DBID: '',
          IsMerge: '',
          Rate: "1.0000",
          Remark: '',
          SubID: '',
          customer_id: user.id,
          id: '',
          name: user.name,
          standard_id: this.item.id,
          xsc_CustomerID: '',
          xsc_HouseChargeID: '',
          xsc_PaidCustomerType: "",
          xsc_id: '',
          checked:false,
        }
        let type = false;
        this.chargeitem_list.map(req=>{
          if(req.customer_id == user.id){
            type = true;
          }
        })
        if(type == true){
          this.$Message.error("操作成功，已存在"+user.name);
        }else{
          //添加
          if(this.index == 1){
            this.chargeitem_list.push(data);
          }
          //修改
          if(this.index == 2){
            this.chargeitem_list[this.user_index].name = data.name;
            this.chargeitem_list[this.user_index].customer_id = data.customer_id;
          }
        }
      }
    },
    //点击修改
    updates(index){
      this.index = 2;
      this.user_index = index;
      this.modal1 = true;
    },

    checked_scope(id,index){
      this.chargeitem_list[index].checked = !this.chargeitem_list[index].checked;
    },
    //设置
    setup(item){
      this.seup = 2;
      this.item = item;
      ERP.showLoading();
      this.$myhttp.post('admin/RoomSetUpUser/setup',item,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          ERP.hideLoading();
          if(backdata.data.code == 200){
              this.chargeitem_list = backdata.data.data;
          }else{
            this.$Message.error(backdata.data.message);
          }
      });
    },
    //点击费用类型
    chargeitem_types(){
      this.$myhttp.get("admin/RoomSetUp/chargeitem_type?chargeitem_type="+this.data.chargeitem_type_id,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.chargeitem_1 = backdata.data.data;
      });
    },
    //点击收费项目
    chargeItem_names(){
      this.$myhttp.get("admin/RoomSetUp/chargeItem_name?chargeItem_name_id="+this.data.chargeItem_name_id+"&pid="+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.charge = backdata.data.data;
      });
    },
    //选择收费标准
    charges(id,index){
      let checked = this.chargeitem_list[index].checked;
      checked.map(req=>{
        if(req.id == id){
          this.chargeitem_list[index].price = req.charge;
        }
      })
    },
    //保存
    postAdd(){
      //console.log(this.chargeitem_list)
      ERP.showLoading();
      this.$myhttp.post('admin/RoomSetUpUser/updatesAdd',this.chargeitem_list,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          ERP.hideLoading();
          if(backdata.data.code == 200){
            this.seup = 1;
            this.type = '';
            this.data_list = [];
            this.$Message.success('操作成功!');
            this.change(1);
            this.checked_list = [];//选择收费项目清空
          }else{
            this.$Message.error(backdata.data.message);
          }
      });
    },
    //清除
    del(){
      this.$confirm('确定要删除吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$myhttp.post('admin/RoomSetUpUser/del',this.checked,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
               if(backdata.data.code == 200){
                 this.change(1);
                 this.$Message.success('操作成功!');
               }else{
                 this.$Message.error(backdata.data.message);
               }
          });
        }).catch(() => {

        });
    },
    //全部清除
    del_list(){
      if(!this.data.homeName){
        this.$Message.error("点击左边树，选择需要删除的范围！");
        return false;
      }
      this.$confirm('当前选择：'+this.data.homeName+'，确定要全部删除吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let list = {'homeName':this.data.homeName};
          this.$myhttp.post('admin/RoomSetUpUser/del_list',list,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
               if(backdata.data.code == 200){
                 this.change(1);
                 this.$Message.success('操作成功!');
               }else{
                 this.$Message.error(backdata.data.message);
               }
          });
        }).catch(() => {

        });
    },
    tup(){
      this.seup = 1;
      this.checked_list = [];
    },
    //全选
    // checkeds_list(){
    //   console.log(this.checkeds)
    //   if(this.checkeds == true){
    //     this.checked={
    //       checked0:this.desserts[0].id,
    //       checked1:this.desserts[1].id,
    //       checked2:this.desserts[2].id,
    //       checked3:this.desserts[3].id,
    //       checked4:this.desserts[4].id,
    //       checked5:this.desserts[5].id,
    //       checked6:this.desserts[6].id,
    //       checked7:this.desserts[7].id,
    //       checked8:this.desserts[8].id,
    //       checked9:this.desserts[9].id,
    //       checked10:this.desserts[10].id,
    //       checked11:this.desserts[11].id,
    //     }
    //   }else{
    //     this.checked={
    //       checked0:"",
    //       checked1:"",
    //       checked2:"",
    //       checked3:"",
    //       checked4:"",
    //       checked5:"",
    //       checked6:"",
    //       checked7:"",
    //       checked8:"",
    //       checked9:"",
    //       checked10:"",
    //       checked11:"",
    //     }
    //   }
    // },
    handleSelectionChange(val) {
      this.checked={
        checked0:"",
        checked1:"",
        checked2:"",
        checked3:"",
        checked4:"",
        checked5:"",
        checked6:"",
        checked7:"",
        checked8:"",
        checked9:"",
        checked10:"",
        checked11:"",
      };
      let order = val;
      order.map((req,index)=>{
        if(index == 0){
          this.checked.checked0 = req.id;
        }
        if(index == 1){
          this.checked.checked1 = req.id;
        }
        if(index == 2){
          this.checked.checked2 = req.id;
        }
        if(index == 3){
          this.checked.checked3 = req.id;
        }
        if(index == 4){
          this.checked.checked4 = req.id;
        }
        if(index == 5){
          this.checked.checked5 = req.id;
        }
        if(index == 6){
          this.checked.checked6 = req.id;
        }
        if(index == 7){
          this.checked.checked7 = req.id;
        }
        if(index == 8){
          this.checked.checked8 = req.id;
        }
        if(index == 9){
          this.checked.checked9 = req.id;
        }
        if(index == 10){
          this.checked.checked10 = req.id;
        }
        if(index == 11){
          this.checked.checked11 = req.id;
        }
      })
    },
    remoteMethod(query){
      if (query !== '') {
        // console.log(query);
        this.loading = true;
        this.$myhttp.get('admin/common/house_text?text='+query+'&project_id='+this.project_id,{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
        });
      } else {
        this.selectList = [];
      }
    },
    //获得当前多少页,分页
    change(e){
      this.dates();
      //ERP.showLoading()
      this.data.page = e;
      this.$myhttp.post('admin/RoomSetUpUser/index',this.data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          let data = backdata.data.data;
          this.desserts = data.data;
          this.total = data.count;
          this.page = data.pageSize;
          this.chargeitem_type = data.chargeitem_type;
          //ERP.hideLoading()
      });
      this.checkeds = false;
      this.checked={
        checked0:"",
        checked1:"",
        checked2:"",
        checked3:"",
        checked4:"",
        checked5:"",
        checked6:"",
        checked7:"",
        checked8:"",
        checked9:"",
        checked10:"",
        checked11:"",
      };
    },
    //时间转换
    dates(){
      this.data.startDate = '';
      this.data.endDate = '';
      if(this.startDate != null && this.startDate != ''){
        let d = this.startDate;//开始时间
        let startDate = new Date(d).getTime()/1000;
        startDate = Number(startDate).toFixed(0);
        this.data.startDate = startDate;
      }
      if(this.endDate != null && this.endDate != ''){
        let d = this.endDate;//开始时间
        let endDate = new Date(d).getTime()/1000;
        endDate = Number(endDate).toFixed(0);
        this.data.endDate = endDate;
      }
    },

    //搜索
    searchs(){
      this.change(1);
    },
    // 树组件点击触发
    nodeClick(data) {
      let project = data.tree[0];
      this.project_id = project.pindex_id;
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      //console.log(data.tree)
      this.data.pid = data.tree[0]['id'];
      this.data.homeName=tree_str;
      this.house = tree_str;
      // this.change(1);
      this.data.house_id = '';
      this.search=tree_str;
      if(data.tree[data.tree.length-1].type==='room'){
        this.data.house_id = data.tree[data.tree.length-1].id;
      }
      this.change(1);
    }
  },
  watch:{
    "search"(e){
      let _this = this;
      _this.data.homeName=e;
      let list = _this.selectList;
      list.map(function(it){
        if(e == it.house){
          _this.data.house_id = it.id;
        }
      })
    }
  },

  components: {
    "erp-tree": () => import('../../Common/erp-tree.vue'),
    "room-user": () => import('../../Common/room-user.vue')
  },

}
</script>
<style scoped>
@import '../../../../assets/css/table.css';
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin{
  margin-left:1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/room/RoomSetUpUser.vue